module.exports = __webpack_public_path__ + "static/media/WFP-WORDMARK-STACKED-WHITE.57f51bc0.png";